import { DownloadButton } from './DownloadButton';

interface BookHeroProps {
  bookId: string;
  title: string;
  authorName: string;
  genre: string;
  totalWordCount: number;
  chapterCount: number;
  coverUrl: string | null;
}

function formatWordCount(count: number): string {
  return count.toLocaleString();
}

export function BookHero({
  bookId,
  title,
  authorName,
  genre,
  totalWordCount,
  chapterCount,
  coverUrl,
}: BookHeroProps) {
  return (
    <section className="flex flex-col sm:flex-row gap-8 sm:gap-10 items-center sm:items-start">
      {coverUrl ? (
        <div className="flex-shrink-0">
          <img
            src={coverUrl}
            alt={`Cover of ${title}`}
            className="max-h-[320px] w-auto rounded-card shadow-sm border-b border-border"
          />
        </div>
      ) : (
        <div className="flex-shrink-0 w-[200px] h-[300px] rounded-card border border-border bg-surface flex items-center justify-center">
          <span className="text-xs text-placeholder uppercase tracking-wider">No cover</span>
        </div>
      )}

      <div className="text-center sm:text-left flex flex-col gap-4 sm:pt-4">
        <div>
          <h2 className="font-display text-[28px] font-normal italic text-heading [font-variation-settings:'opsz'_96,'SOFT'_60]">
            {title}
          </h2>
          <p className="text-sm text-muted-foreground mt-1">by {authorName}</p>
        </div>

        <p className="font-mono text-xs text-muted-foreground">
          {genre}
          <span className="mx-1.5" aria-hidden="true">·</span>
          {formatWordCount(totalWordCount)} words
          <span className="mx-1.5" aria-hidden="true">·</span>
          {chapterCount} {chapterCount === 1 ? 'chapter' : 'chapters'}
        </p>

        <DownloadButton bookId={bookId} />
      </div>
    </section>
  );
}
